<app-banner-section
  [isLoading]="allAPIsResp[cacheKeys?.banners]?.isLoading"
  [banners]="allAPIsResp[cacheKeys?.banners]?.data"
></app-banner-section>

<app-statistics-section
  [isLoading]="allAPIsResp[cacheKeys?.statistics]?.isLoading"
  [allStatistics]="allAPIsResp[cacheKeys?.statistics]?.data"
></app-statistics-section>

<app-whats-new-section
  [isLoading]="allAPIsResp[cacheKeys?.whatsNewSrvs]?.isLoading"
  [whatsNewServices]="allAPIsResp[cacheKeys?.whatsNewSrvs]?.data"
></app-whats-new-section>

<app-popular-services-section
  [isLoading]="allAPIsResp[cacheKeys?.popularSrvs]?.isLoading"
  [popularServices]="allAPIsResp[cacheKeys?.popularSrvs]?.data"
></app-popular-services-section>

<app-trending-services-section
  [isLoading]="allAPIsResp[cacheKeys?.trendingSrvs]?.isLoading"
  [trendingServices]="allAPIsResp[cacheKeys?.trendingSrvs]?.data"
></app-trending-services-section>

<app-state-section></app-state-section>

<app-benefits-section></app-benefits-section>

<app-categories-section
  [isLoading]="allAPIsResp[cacheKeys.categories].isLoading"
  [categories]="allAPIsResp[cacheKeys.categories].data"
></app-categories-section>

<!-- <app-my-scheme-section></app-my-scheme-section> -->

<app-customer-support-section></app-customer-support-section>

<app-download-app-section></app-download-app-section>
